import { api, publicGet } from './client';

export interface CheckoutConfig {
  priceCents: number;
  pixKey: string;
}

export interface PixPayment {
  paymentId: string;
  ticketUrl: string;
  qrCode: string;
  pixCopyPaste: string;
  amount: number;
}

export interface PaymentStatus {
  id: string;
  status: 'pending' | 'approved' | 'rejected' | 'cancelled';
  amount: string;
  confirmedAt: string | null;
}

export interface PaymentRecord {
  id: string;
  householdId: string;
  cognitoUserId: string;
  amount: string;
  status: string;
  createdAt: string;
  confirmedAt: string | null;
  memberName: string | null;
  memberPlan: 'FREE' | 'PREMIUM';
  memberPlanUntil: string | null;
}

export interface AboutSettings {
  'about-description': string;
  'about-contact-email': string;
  'about-whatsapp': string;
  'app-name': string;
  'app-tagline': string;
  'terms-url'?: string;
  'privacy-url'?: string;
  'support-url'?: string;
  'premium-price'?: string;
}

export interface AdminSettingsPayload {
  'about-description'?: string;
  'about-contact-email'?: string;
  'about-whatsapp'?: string;
  'app-name'?: string;
  'app-tagline'?: string;
  'premium-price'?: string;
  'terms-url'?: string;
  'privacy-url'?: string;
  'support-url'?: string;
}

export const paymentApi = {
  createPix: (email: string) => api.post<PixPayment>('/payment/pix', { email }),
  getStatus: (paymentId: string) => api.get<PaymentStatus>(`/payment/status/${paymentId}`),
  // ADR 024 — manual check: queries the Mercado Pago API and confirms the
  // payment (idempotent) instead of only reading the local status.
  checkPayment: (paymentId: string) =>
    api.get<PaymentStatus>(`/payment/status/${paymentId}/check`),
  getCheckoutConfig: () => api.get<CheckoutConfig>('/payment/checkout-config'),
  listPayments: () => api.get<PaymentRecord[]>('/admin/payments'),
  confirmPayment: (paymentId: string) =>
    api.patch<PaymentRecord>(`/admin/payments/${paymentId}/confirm`, {}),
};

export const settingsApi = {
  getAbout: () => publicGet<AboutSettings>('/settings/about'),
  updateSettings: (data: AdminSettingsPayload) =>
    api.patch<AboutSettings>('/admin/settings', data),
};
